import { useEffect, useState } from "react";
import { ReactComponent as Image } from "../../assets/icons/Image.svg";
import { useGetCompanyQuery } from "../../store/Company/companyApiSlice";
import { useGetCompanyNewQuery } from "../../store/search/searchApiSlice";
import { getCountryByCode } from "../../utils/Helper";

export const PurchaseList = (props) => {
  const [checkTrevexCompany, setCheckTrevexCompany] = useState(false);
  const [trevexID, setTrevexID] = useState("");
  const [winID, setWinID] = useState("");
  const { companyID, purchaseDate, token } = props;
  useEffect(() => {
    if (companyID?.startsWith("TRX")) {
      setCheckTrevexCompany(true);
      setTrevexID(companyID);
    } else {
      setCheckTrevexCompany(false);
      setWinID(companyID);
    }
  }, [companyID]);
  // Every map it will call this API, Need to Remove the API the API
  const { data } = useGetCompanyQuery(
    {
      token: token,
      companyId: trevexID,
    },
    { enabled: !!trevexID }
  );
  const { data: worldBoxCompany } = useGetCompanyNewQuery(
    {
      id: winID,
    },
    { enabled: !!winID }
  );
  return (
    <>
      <div className="text-company text-left px-3 py-2 my-2 rounded flex text-f14 justify-between hover:bg-header">
        <div className="flex gap-3 pt-2">
          <Image />
          <div className="flex flex-col">
            <span className="font-normal text-secondarytwo">
              {checkTrevexCompany
                ? data?.registered_company_name
                : worldBoxCompany?.company?.name}
            </span>
            <span className="location text-secondary font-light pt-1">
              {data?.companyID?.startsWith("TRX") &&
                data?.companyAddress[0]?.company_address_detailsID
                  ?.state &&
                `${data?.companyAddress[0]?.company_address_detailsID?.state}, `}
              {getCountryByCode(
                checkTrevexCompany
                  ? data?.country_code
                  : worldBoxCompany?.company?.countrycode
              )}
            </span>
          </div>
        </div>
        <div className="flex flex-col pt-2">
          <span className="text-secondary text-f12 font-light">
            Purchased on{" "}
          </span>
          <span className="date text-secondarytwo text-12">{purchaseDate}</span>
        </div>
      </div>
    </>
  );
};
